// API service for food items operations
const API_BASE_URL = 'http://localhost:3001/api'

class FoodItemsApiService {
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    }

    try {
      const response = await fetch(url, config)
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      // Handle responses with no content (like DELETE 204)
      if (response.status === 204 || response.headers.get('content-length') === '0') {
        return null
      }
      
      return await response.json()
    } catch (error) {
      console.error('API request failed:', error)
      throw error
    }
  }

  // Get all food items - POST method
  async getFoodItems(menuType = null) {
    // Default to 'FTT' if menuType is not provided or is null
    const defaultMenuType = menuType || 'FTT'
    
    // Use external API for food items
    const response = await fetch('https://authalt.bsynapse.com/atmantannuggets/fooditems', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ menuType: defaultMenuType })
    })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    return response.json()
  }
}

const foodItemsApiService = new FoodItemsApiService()
export default foodItemsApiService

